import firebase from 'firebase/app';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { UserVerified } from '../../../models/main.model';
import { AppRoutes } from '../../Routing/routing.model';

export const isUserVerified = (currentUser: firebase.User): UserVerified | null => {
  const [userVerified, setUserVerified] = useState<UserVerified>({
    verified: false,
    message: 'Błąd',
    description: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    action: () => {},
    routeName: null,
  });
  const { push } = useHistory();

  useEffect(() => {
    if (!currentUser) return;

    if (!currentUser.emailVerified) {
      setUserVerified({
        verified: false,
        message: 'Potwierdź adres email',
        description: 'Nie możesz podpisać umowy gdy nie masz potwierdzonego adresu email',
        action: () => {
          push(AppRoutes.MOJA_TABLICA_ACCOUNT_INFO);
        },
        routeName: 'Potwierdź email',
      });
    } else {
      setUserVerified((prevState) => ({ ...prevState, verified: true }));
    }
  }, [currentUser]);

  return userVerified;
};
